// React
import React, { useEffect, useState } from 'react';
// External
import { Button, CardDeck, Image } from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
// Internal
import BundleCard from 'components/shared/molecules/BundleCard/BundleCard';
import CustomTable from 'components/shared/molecules/CustomTable/CustomTable';
import BundleCustomProduct from 'components/shared/atoms/BundleCustomProduct/BundleCustomProduct';
import { updateBooking } from 'stores/actions';
// Images
import imageFallback from 'assets/images/image-not-available.png';
// Styles
import './styles.scss';
// Models
import Product from 'models/Product';
// Services
import ProductService from 'services/product';
// Constants
import PRODUCT_CATEGORIES from 'constants/productCategories';
import ProductModal from 'components/shared/organisms/ProductModal/ProductModal';
import isEmpty from 'lodash/isEmpty';
// import Booking from 'models/Booking';

/**
 * @param {string} props.data - The text to be display in the previous button
 * @param {string} props.displayCustomisation - The bundle view to display
 *                                              if it's selection of options or customisation
 * @todo Change select input to customise the select options (Style)
 */
class SelectBundle extends React.Component {
    constructor(props) {
        super(props);
        const page = new URLSearchParams(window.location.search).get('page');
        this.state = {
            bundleList: [],
            bundleSelected: null,
            currentPage: page,
            itemsPerPage: 10,
            productModalEnabled: false,
            hasBundleInCart: false,
            shouldSkip: false,
        };
        this.getProductList();
    }

    async getProductList() {
        const params = {
            category: PRODUCT_CATEGORIES.cremationPackages,
            page: this.state.currentPage,
            page_size: this.state.itemsPerPage,
            serviceType: this.props.booking.getServiceTypeName(),
            type: 'package',
        };
        ProductService.getProducts(params)
            .then((response) => {
                if (response.data.data.length) {
                    this.setState({
                        bundleList: response.data.data.map((product) => Product(product)),
                        currentPage: response.data.current_page
                    });
                    this.props.bundleList(this.state.bundleList)
                }
                /**
                 * @todo Add message if no bundle products are available
                 */
            })
            .catch((error) => {
                console.error(error);
            });
    }

    updateBookingProduct(bundle) {
        this.props.updateBooking({ product: bundle });
    }

    closeProductPackages = () => {
        this.setState({ productModalEnabled: false });
        this.props.hasSelected(this.state.hasBundleInCart)
    }

    clickedProcess(item) {
        this.setState({ bundleSelected: item, productModalEnabled: true });
        this.props.hasSelected(this.state.hasBundleInCart)
    }

    componentDidUpdate() {
        this.state.bundleList.forEach((bundle) => {
            if (this.state.shouldSkip) {
                return;
            }

            let hasBundleInCart = this.props.booking.getQuotedProducts().find((quotedProduct) => {
                if (quotedProduct.name === bundle.name) {
                    return true;
                }
            });

            if (!isEmpty(hasBundleInCart)) {
                this.setState({hasBundleInCart: true, shouldSkip: true})
                this.props.hasSelected(true)
                return;
            }
        })
    }

    render() {
        return (
            <div className="bundle-container">
                <BundleView
                    isCustomisation={this.props.displayCustomisation}
                    bundleList={this.state.bundleList}
                    bundleSelected={this.state.bundleSelected}
                    onClick={(item) => this.clickedProcess(item)}
                    onBundleUpdated={(bundle) => this.updateBookingProduct(bundle)}
                    packageSubmitted={this.props.packageSubmitted}
                    hasBundleInCart={this.state.hasBundleInCart}
                    hasSelectedBundle={this.props.hasSelectedBundle}
                />

                {
                    this.state.bundleSelected ?
                    <ProductModal
                        show={this.state.productModalEnabled}
                        onHide={this.closeProductPackages}
                        isPackage={true}
                        product={this.state.bundleSelected}
                    />
                    : ''
                }
            </div>
        );
    }
}

const BundleView = (props) => {
    const [bookingBundle, setBookingBundle] = useState(null);
    const [subProductList, setSubProductList] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState(null);
    const [childSelected, setChildSelected] = useState(null);
    /**
     * @todo save the selected child products in the booking
     */
    const [selectedProductChildren, setSelectedProductChildren] = useState([]);
    const headers = Object.freeze([
        {
            name: 'action',
            id: 'img',
        },
        {
            name: 'item',
            id: 'item',
        },
        {
            name: 'action',
            id: 'action',
        },
    ]);

    useEffect(() => {
        // Get the products of the bundle selected
        if (props.bundleSelected) {
            ProductService.getProductOptions(props.bundleSelected.id)
                .then((response) => {
                    const bundleProducts = response.data['filteredproducts'].map((product) => {
                        if (product[0] !== undefined) {
                            return product.map((product2) => Product(product2));
                        } else {
                            return Product(product);
                        }
                    });
                    setSubProductList(bundleProducts);
                    const product = {};
                    product[props.bundleSelected.id] = {}; // Adds the bundle (package) ID
                    bundleProducts.forEach((item) => {
                        if (item?.packageProduct?.productId) {
                            // Adds the sub product package ID
                            product[props.bundleSelected.id][item?.packageProduct?.productId] = {};
                        }
                    });
                    setBookingBundle(product);
                }).catch((err) => {
                    console.error(err);
                });
        }
    }, [props.bundleSelected]);

    useEffect(() => {
        // Get the child products to customise
        if (selectedProduct?.packageProduct) {
            ProductService.getProductOptions(selectedProduct?.packageProduct?.productId)
                .then((response) => {
                    setSelectedProductChildren(response.data.map((product) => Product(product)));
                    /**
                     * @todo Add message if no child products are available
                     */
                }).catch((err) => {
                    console.error(err);
                });
        }
    }, [selectedProduct]);

    const updateBundle = (child) => {
        setChildSelected(child);
        const bundle = bookingBundle;
        bundle[props.bundleSelected.id][selectedProduct?.packageProduct?.productId] = [{ id: child.id }];
        props.onBundleUpdated(bundle);
    };

    const getFormattedData = () => {
        return subProductList.map((item) => ({
            img: <Image
                className="table-img"
                src=""
                heigth="80"
                onError={(evt) => {
                    evt.target.src = imageFallback;
                }}
            />,
            item: (
                <>
                    <p className="bundle-item-header">
                        {item.name}
                    </p>
                    <p className="bundle-item-sub-header">
                        {item.description}
                    </p>
                    {
                        selectedProduct && selectedProduct.id === item.id
                            ? (
                                <div className="item-customise">
                                    {
                                        selectedProductChildren.map((child) => (
                                            <BundleCustomProduct
                                                key={child.id}
                                                item={child}
                                                onClick={() => updateBundle(child)}
                                                isSelected={childSelected && childSelected.id === child.id}
                                            />
                                        ))
                                    }
                                </div>
                            ) : null
                    }
                </>
            ),
            action: (
                <Button
                    variant="primary"
                    className="btn-customise"
                    style={{ minHeight: '40px' }}
                    onClick={() => {
                        if (!selectedProduct || selectedProduct.id !== item.id) {
                            setSelectedProduct(item);
                            setSelectedProductChildren([]);
                        }
                    }}
                >
                    Customise
                </Button>
            )
        }));
    };

    if (props.isCustomisation) {
        return (
            <div>
                <div className="container-header">
                    <h5>Option selection</h5>
                    <p className="subtitle">
                        The selected bundle requires further customisation,
                        options available are listed below.
                    </p>
                </div>
                {
                    subProductList.length
                        ? (
                            <CustomTable
                                className="bundle-custom-table"
                                data={getFormattedData()}
                                headers={headers}
                            />
                        ) : null
                }
            </div>
        );
    } else if (props.bundleList && props.bundleList.length > 0) {
        return (
            <div>
                <div className="container-header">
                    <span className="package-label-font"><b>Select a package</b></span> &nbsp;
                    {
                        (!props.hasBundleInCart && props.packageSubmitted) || (!props.hasSelectedBundle && props.packageSubmitted) ?
                        <span className="package-warning-font is-invalid"><b>Package selection is required: Please select a package to proceed</b></span>
                        : ''
                    }
                    <p className="subtitle">
                        Choose a cremation package from the options below.
                        Once chosen, click details to customise from available options and add to booking.
                    </p>
                </div>

                <CardDeck className="bundle-card-deck">
                    {
                        props.bundleList.map((bundle) => (
                            <BundleCard
                                key={bundle.id}
                                item={bundle}
                                show_modal={false}
                                onClick={() => props.onClick(bundle)}
                                isSelected={!!(props.bundleSelected && props.bundleSelected.id === bundle.id)}
                            />
                        ))

                    }
                </CardDeck>
            </div>
        );
    }
    return <p className="mt-4 text-center">No bundles are available.</p>;
};

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectBundle));
